import {modify} from "mythil/object";
import setStateValue from "~/reducers/helpers/setStateValue";
import {normalizeValueDependencies, prepareFieldValues, presentUpdatedValues} from "~/statePresenter";
import {getValueAdaptData, getValueAdaptSources} from "~/stateGetter";
import identify from "~/identify";

const setItemDataValue = (model, data, state) => {
    let itemData = model.itemData.value;

    let valueAdaptProps = {
        ...getValueAdaptData(state, model.modelId),
        ...getValueAdaptSources(state, model.modelId)
    };
    valueAdaptProps = { ...valueAdaptProps,  ...normalizeValueDependencies(valueAdaptProps) };

    let values = prepareFieldValues(valueAdaptProps.editFields, valueAdaptProps),
        startValues = prepareFieldValues(valueAdaptProps.editFields, { ...valueAdaptProps, initialEditFieldValues: itemData.initialValues, editFieldValues: itemData.values });

    let updatedValues = presentUpdatedValues({values, startValues});

    model = setStateValue(model, 'itemData', data);

    model = modify(model, 'item.values', { ...data.values, ...updatedValues });
    model = modify(model, 'item.options', data.options);

    return model;
};

export default setItemDataValue;